export class VerifyCodeModel {
    Provider: string;
    Code: string;
    RememberClient: boolean;
    RememberMe: boolean;
    Email: string;
}
